import {
    apiRequest,
    masterWorkUnit,
    masterEmployeeStatus,
    presensiexport,
    presensiketidakhadiranexport,
    masterEmployeeCategories,
} from "../../../../../services/adapters/kepegawaian/presensiService"

import {
    syncJabatanBkn
} from "../../../../../services/adapters/kepegawaian/integrasiService"

class IndexRepository {

    fetchWorkUnit = async (query) => {
        return await apiRequest("get", masterWorkUnit, {
            params: query
        }, true)
    }
    fetchEmployeeStatus = async (query) => {
        return await apiRequest("get", masterEmployeeStatus, {
            params: query
        }, true)
    }

    fetchPresensiExport = async (query) => {
        return await apiRequest("get", presensiexport, {
            params: query
        }, true)
    }

    fetchPresensiKetidakhadiranExport = async (query) => {
        return await apiRequest("get", presensiketidakhadiranexport, {
            params: query
        }, true)
    }

    fetchEmployeeCategories = async (query) => {
        return await apiRequest("get", masterEmployeeCategories, {
            params: query
        }, true)
    }

    fetchSyncJabatanBkn = async (query) => {
        return await apiRequest("get", syncJabatanBkn, {
            params: query
        }, true)
    }
    
}

export default IndexRepository